import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "title", "active", "children"],
      _excluded2 = ["attrs"],
      _excluded3 = ["className", "params"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classnames from 'classnames';
import Render from '@/components/Render';
import { findModuleFromState } from '@/utils/utils.js';
import './index.less';

const renderBy = status => node => {
  return status ? node : null;
};

const Item = (props = {}) => {
  const {
    className,
    title,
    active,
    children
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'params-item': true,
    [className]: !!className,
    active
  });
  const titleNode = renderBy(title)( /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls
  }, others), titleNode, /*#__PURE__*/React.createElement("div", {
    className: "desc"
  }, children));
};

const renderInsureList = (data = {}) => {
  const {
    insuredList = [],
    payType
  } = data;

  if (!insuredList) {
    return null;
  }

  if (!insuredList.length) {
    return null;
  }

  return insuredList.map((item = {}) => {
    const {
      name,
      initialPremium = 0,
      nextPremium = 0
    } = item;
    const desc = Number(payType) === 1 ? `${initialPremium}元` : `首月${initialPremium}元，次月${nextPremium}元`;
    return /*#__PURE__*/React.createElement(Item, {
      active: true,
      title: name
    }, desc);
  });
};

const useContent = params => {
  // eslint-disable-next-line no-undef
  const premium = useStore('premium');
  const {
    type,
    shit,
    value = 0,
    data = {}
  } = premium;
  const {
    insuredList = []
  } = data;
  const suffix = shit ? '元' : '元起';
  let initialPremium = 0;
  let nextPremium = 0;

  if (Array.isArray(value)) {
    [initialPremium, nextPremium] = value;
  } else {
    initialPremium = value;
  }

  if (params === 'insurentCount') {
    if (!insuredList) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Item, {
      title: "\u88AB\u4FDD\u4EBA\u4EBA\u6570"
    }, insuredList.length, "\u4EBA");
  }

  if (params === 'initialPremium') {
    const title = type === 'month' ? '首期保费' : '保费';
    return /*#__PURE__*/React.createElement(Item, {
      active: true,
      title: title
    }, initialPremium, "\u5143");
  }

  if (params === 'nextMonthPremium') {
    if (type !== 'month') {
      return null;
    }

    return /*#__PURE__*/React.createElement(Item, {
      active: true,
      title: "\u6B21\u6708\u4FDD\u8D39"
    }, nextPremium, suffix, "/\u6708\xA0\u517111\u671F");
  } // 被保人及价格


  if (params === 'insurentAndPrice') {
    if (!insuredList) {
      return null;
    }

    return renderInsureList(data);
  } // 声明


  if (params === 'statement') {
    const fn = (curr = {}) => curr.component === 'healthClause';

    let clauseModule = findModuleFromState(fn);

    if (!clauseModule) {
      return;
    }

    const {
      attrs = {}
    } = clauseModule,
          others = _objectWithoutProperties(clauseModule, _excluded2);

    if (attrs) {
      clauseModule = _objectSpread({
        attrs: _objectSpread(_objectSpread({}, attrs), {}, {
          dummy: true,
          confirm: false
        })
      }, others);
    }

    return /*#__PURE__*/React.createElement(Render, {
      components: [clauseModule]
    });
  }
};

const Params = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs
  } = props;

  const {
    className,
    params
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded3);

  const cls = classnames({
    'components-params-render': true,
    special: params !== 'statement',
    [className]: !!className
  });
  const content = useContent(params) || null;

  if (!content) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), content);
});
export default Params;